export default __webpack_public_path__ + "static/media/Foyer_V.4.eb3e0cf2.jpg";